// src/hooks/useGameGroup.ts
import { useLocalStorage } from '@rehooks/local-storage';
import { GameGroup } from '../constants/Games';

// Wybraną grupę gier pamięta przeglądarka, wspólnie dla wszystkich kont — wylogowanie jej nie czyści.
// Za pierwszym razem, a także przy nieznanej wartości w pamięci, menu pokazuje gry dla starszych.
const useGameGroup = (): [GameGroup, (group: GameGroup) => void] => {
  const [stored, setStored] = useLocalStorage<GameGroup>('gameGroup', GameGroup.OLDER);

  return [stored === GameGroup.KIDDO ? GameGroup.KIDDO : GameGroup.OLDER, setStored];
};

export default useGameGroup;
